module.exports = __webpack_public_path__ + "images/landing/video-previews/new-recipe_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/new-recipe_2x.jpg
// module id = 9eMJ
// module chunks = 1